import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import DownloadIcon from '@mui/icons-material/Download';

import { fetchStudentVideoDownloadUrl } from '../api';

const DownloadVideoButton = ({ studentUsername, videoKey, onError }) => {
    const downloadVideo = async () => {
        try {
            const url = await fetchStudentVideoDownloadUrl(studentUsername, videoKey);
            // Click a temporary link instead of navigating the SPA, so an S3 error page
            // (expired/missing object) opens in a new tab rather than replacing the dashboard
            const a = document.createElement('a');
            a.href = url;
            a.download = '';
            a.target = '_blank';
            a.rel = 'noopener';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        } catch (err) {
            console.error(err);
            if (onError) onError('Failed to download video.');
        }
    };

    return (
        <Tooltip title="Download Video">
            <Button
                onClick={downloadVideo}
                aria-label="Download Video"
                sx={{
                    textDecoration: 'none',
                    color: '#4447ad',
                    border: '1px solid rgba(68, 71, 173, 0.5)',
                    borderRadius: '4px',
                    padding: '4px 8px',
                }}
            >
                <DownloadIcon sx={{ fontSize: 30 }} />
            </Button>
        </Tooltip>
    );
};

export default DownloadVideoButton;
